import { render, staticRenderFns } from "./VmTable.vue?vue&type=template&id=d178faf2&"
import script from "./VmTable.vue?vue&type=script&lang=js&"
export * from "./VmTable.vue?vue&type=script&lang=js&"
import style0 from "./VmTable.vue?vue&type=style&index=0&id=d178faf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports